/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_AllInputs */

const cs_templates_empty_all = /** @type {(inputs: Templates_Empty_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné šablony v knihovně.`)
};

const en_templates_empty_all = /** @type {(inputs: Templates_Empty_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No templates in the library yet.`)
};

/**
* | output |
* | --- |
* | "No templates in the library yet." |
*
* @param {Templates_Empty_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_all = /** @type {((inputs?: Templates_Empty_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_all(inputs)
	return cs_templates_empty_all(inputs)
});